import {
  CHANGE_ALERT_STATUS,
  CHANGE_ALERT_STATUS_FAIL,
  CHANGE_ALERT_STATUS_SUCCESS,
  CHANGE_ALERT_ASSIGN_TO_USER,
  CHANGE_ALERT_ASSIGN_TO_USER_FAIL,
  CHANGE_ALERT_ASSIGN_TO_USER_SUCCESS,
  FETCH_ALERT_DETAILS_BY_ALERT_ID,
  FETCH_ALERT_DETAILS_BY_ALERT_ID_FAIL,
  FETCH_ALERT_DETAILS_BY_ALERT_ID_SUCCESS,
  FETCH_WHITELIST_BY_CUSTOMER,
  FETCH_WHITELIST_BY_CUSTOMER_FAIL,
  FETCH_WHITELIST_BY_CUSTOMER_SUCCESS,
  UPDATE_WHITELIST_BY_CUSTOMER,
  UPDATE_WHITELIST_BY_CUSTOMER_FAIL,
  UPDATE_WHITELIST_BY_CUSTOMER_SUCCESS,
  TOGGLE_ALERT_NOTE,
  CHANGE_ALERT_ASSIGN_SUCCESS,
  RESET_ERROR_MESSAGE
} from '../../actions/cm/alertDetails';

export const initialState = {
  isLoading: false,
  hasError: false,
  alertDetails: {},
  showAlertNote: false,
  alertAssignSuccess: false,
  errorMessage: '',
  whitelistCustomerData: {
    isLoading: false,
    error: null,
    data: null,
    updateSuccess: false,
    hasError: false
  }
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_ALERT_DETAILS_BY_ALERT_ID:
      return {
        ...state,
        isLoading: true,
        hasError: false,
        errorMessage: ''
      };
    case FETCH_ALERT_DETAILS_BY_ALERT_ID_SUCCESS:
      return {
        ...state,
        alertDetails: payload,
        isLoading: false
      };
    case FETCH_ALERT_DETAILS_BY_ALERT_ID_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        errorMessage: payload.message
      };
    case FETCH_WHITELIST_BY_CUSTOMER:
      return {
        ...state,
        whitelistCustomerData: {
          isLoading: true,
          data: null,
          error: null,
          updateSuccess: false
        }
      };
    case FETCH_WHITELIST_BY_CUSTOMER_SUCCESS:
      return {
        ...state,
        whitelistCustomerData: {
          isLoading: false,
          data: payload,
          error: null,
          hasError: false
        }
      };
    case FETCH_WHITELIST_BY_CUSTOMER_FAIL:
      return {
        ...state,
        whitelistCustomerData: {
          isLoading: false,
          data: null,
          error: payload.message,
          hasError: true
        }
      };

    case UPDATE_WHITELIST_BY_CUSTOMER:
      return {
        ...state,
        whitelistCustomerData: {
          isLoading: true,
          error: null,
          updateSuccess: false
        }
      };
    case UPDATE_WHITELIST_BY_CUSTOMER_SUCCESS:
      return {
        ...state,
        whitelistCustomerData: {
          isLoading: false,
          data: null,
          error: null,
          updateSuccess: true,
          hasError: false
        }
      };
    case UPDATE_WHITELIST_BY_CUSTOMER_FAIL:
      return {
        ...state,
        whitelistCustomerData: {
          isLoading: false,
          error: payload.message,
          hasError: true
        }
      };
    case CHANGE_ALERT_STATUS:
      return {
        ...state,
        isLoading: true,
        hasError: false,
        errorMessage: ''
      };
    case CHANGE_ALERT_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    case CHANGE_ALERT_STATUS_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        errorMessage: payload.message
      };
    case CHANGE_ALERT_ASSIGN_TO_USER:
      return {
        ...state,
        isLoading: true,
        hasError: false,
        errorMessage: ''
      };
    case CHANGE_ALERT_ASSIGN_TO_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        alertAssignSuccess: true
      };
    case CHANGE_ALERT_ASSIGN_TO_USER_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        alertAssignSuccess: false,
        errorMessage: payload.message
      };
    case TOGGLE_ALERT_NOTE:
      return {
        ...state,
        showAlertNote: payload.isOpen
      };
    case CHANGE_ALERT_ASSIGN_SUCCESS:
      return {
        ...state,
        alertAssignSuccess: false
      };
    case RESET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: '',
        hasError: false
      };

    default:
      return state;
  }
}
